import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {NgxBootstrapSliderModule} from 'ngx-bootstrap-slider';

import {HeaderComponent} from './header/header.component';
import {LivestreamPlayerComponent} from './livestream-player/livestream-player.component';
import {LivestreamCurrentShowComponent} from './livestream-current-show/livestream-current-show.component';
import {AppRoutingModule} from '../../app-routing.module';
import {PagesModule} from '../pages/pages.module';
import { MainMenuComponent } from './main-menu/main-menu.component';

@NgModule({
  declarations: [
    HeaderComponent,
    LivestreamPlayerComponent,
    LivestreamCurrentShowComponent,
    MainMenuComponent,
  ],
  imports: [
    AppRoutingModule,
    CommonModule,
    NgxBootstrapSliderModule,
    PagesModule
  ],
  exports: [
    HeaderComponent
  ]
})
export class HeaderModule {
}
